import { PlusCircleIcon } from "@phosphor-icons/react";
import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { BannersPlacement } from "@/components/BannersPlacement/BannersPlacement";
import { Button } from "@/components/Button/Button";
import { Image } from "@/components/Image/Image";
import { useBannersPlacementQuery } from "@/hooks/useBannersPlacement";
import { BannersPlacementSlug } from "@/types/enums";

export function TravellersEmptyState() {
  const navigate = useNavigate();
  const intl = useIntl();

  const { data: placement, isPending } = useBannersPlacementQuery(
    BannersPlacementSlug.TRAVELLERS_EMPTY_STATE,
  );
  const hasBanners =
    !isPending &&
    placement?.isEnabled === true &&
    (placement.banners.length ?? 0) > 0;

  return (
    <div className="flex flex-col items-center gap-6 pt-8">
      <div className="size-60">
        <Image
          src="/illustrations/travellersEmptyState.svg"
          alt=""
          aria-hidden
        />
      </div>

      <div className="flex flex-col items-center gap-2 text-center">
        <h2 className="text-lg font-semibold text-text-primary">
          {intl.formatMessage({
            defaultMessage: "No Saved Travellers!",
            description:
              "Title shown when user has no saved traveller profiles",
          })}
        </h2>
        <p className="text-base text-text-secondary">
          {intl.formatMessage({
            defaultMessage:
              "Add a traveler to make your next booking faster and easier",
            description:
              "Subtitle shown when user has no saved traveller profiles",
          })}
        </p>
      </div>

      <Button
        variant="contained"
        startIcon={<PlusCircleIcon size={20} />}
        onClick={() => navigate({ to: "/travelers", search: { new: true } })}
      >
        {intl.formatMessage({
          defaultMessage: "Add Traveller",
          description:
            "CTA button on empty travellers state to add a new traveller",
        })}
      </Button>

      {hasBanners && (
        <div className="w-full">
          <h2 className="mb-3 text-lg font-semibold text-text-title">
            {intl.formatMessage({
              defaultMessage: "Offers",
              description:
                "Section title for promotions on empty travellers state",
            })}
          </h2>
          <BannersPlacement
            slug={BannersPlacementSlug.TRAVELLERS_EMPTY_STATE}
          />
        </div>
      )}
    </div>
  );
}
